import { Injectable } from '@angular/core';
import { urlServices } from '../services/outboundServiceUrls';
import { HttpServiceService } from 'src/app/common-service/http-service.service';
import { retry } from 'rxjs/operators';
import { state } from '@angular/animations';
import { Observable } from 'rxjs-compat';
import { encryptionService } from 'src/app/common-service/cedService';
import { ServerURLService } from 'src/app/common-service/serverURL.service';

@Injectable({
  providedIn: 'root'
})
export class OutboundService {

  constructor(public http: HttpServiceService, public url: urlServices, public ced: encryptionService, public serverURL: ServerURLService) { }

  // outbound apis
  // get calls
  // getAllOrganizations
  getAllOrganizations() {
    return this.http.get(this.url.getAllOrganizations);
  }

  trackWithSearch(userId:any,obj:any,pageid:any,rowid:any){
    if (obj === null) {
      return this.http.get(this.url.trackWithSearch + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
        + '&page=' + pageid + '&rows=' + rowid);
    } else {
      return this.http.get(this.url.trackWithSearch + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
        + obj + '&page=' + pageid + '&rows=' + rowid);
    }  }

  // getAllDesignations
  getAllDesignations() {
    return this.http.get(this.url.getAllDesignations);
  }
  // getAllDCISections
  getAllDCISections() {
    return this.http.get(this.url.getAllDCISections);
  }
  // getSubSections
  getSubSections(sectionid) {
    const obj = {
      sectionIdEncr: this.ced.encryptAesToString(sectionid, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.getSubSections, obj);
  }
  // getDispatchTypes
  getDispatchTypes() {
    return this.http.get(this.url.getDispatchTypes);
  }
  // getDispatchItems
  getDispatchItems() {
    return this.http.get(this.url.getDispatchItem);
  }
  // getAllDispatches
  getAllDispatches(pageid: number, rowid: number) {
    return this.http.get(this.url.getAllDispatches + '?page=' + pageid + '&rows=' + rowid);
  }
  // getDispatchById
  getDispatchById(dispatchId: any) {
    const dispatchIdEncr = encodeURIComponent(this.ced.encryptAesToString(dispatchId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getDispatchById  + '?dispatchIdEncr=' + dispatchIdEncr);
  }

  // getAllCounts
  getCounts() {
    return this.http.get(this.url.getCounts);
  }
  // generateDispatchReferenceNumber
  generateDispatchRefNo(patternNumber: any) {
    return this.http.get(this.url.generatedReferenceNo + '?pattern=' + patternNumber);
  }
  // searchDataDashboard
  searchDispatches(searchvalue: any, pageid: number, rowid: number) {
    return this.http.get(this.url.searchData + '?searchInput=' + searchvalue +
      '&page=' + pageid + '&rows=' + rowid);
  }
  // dispatchdetailsbetweendates
  dispatchDetailsBetweenDates(startdate: any, enddate: any, pageid: any, rowid: any) {
    return this.http.get(this.url.dispatchDatesBetweenDates + '?startDate=' + startdate
      + '&endDate=' + enddate + '&page=' + pageid + '&rows=' + rowid);
  }
  // dispatchdetails by status
  dispatchdetailsByStatus(statuscode: any, pageid: any, rowid: any) {
    return this.http.get(this.url.getAllDispatchDetailsByStatus + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&status=' + statuscode
      + '&page=' + pageid + '&rows=' + rowid);

  }

  // sectionexecutive apicalls 
  // dispatchdetailsdashboardwithpagination
  dispatchdetailsWithPagiantion(userid: any, pageid: any, rowid) {
    return this.http.get(this.url.getAllDispatchDetailsByUser + '?userId=' + userid
      + '&page=' + pageid + '&rows=' + rowid);
  }
  // getAllDispatchDetailsUserBetweenDates
  getAllDispatchDetailsUserBetweenDates(startdate: any, enddate: any, pageid: any, rowid: any, userId: any) {
    return this.http.get(this.url.getAllDispatchDetailsUserBetweenDates + '?startDate=' + startdate
      + '&endDate=' + enddate + '&page=' + pageid + '&rows=' + rowid + '&userId=' + userId);
  }
  // searchDispatchDetailsByUser
  searchDispatchDetailsByUser(userid: any, searchvalue: any, pageid: number, rowid: number,) {
    return this.http.get(this.url.searchDispatchDetailsByUser + '?userId=' + userid
      + '&searchInput=' + searchvalue + '&page=' + pageid + '&rows=' + rowid);
  }

  // daksecexecutiveapicalls
  // dispatchdetails by status and between dates
  dispatchdetailsByStatusAndDates(status: any, startdate: any, enddate: any, pageid: any, rowid: any) {
    return this.http.get(this.url.getAllDispatchDetailsByStatusandBetweenDates + '?status=' + status
      + '&startDate=' + startdate + '&endDate=' + enddate + '&page=' + pageid + '&rows=' + rowid);
  }
  // searchDataDashboard
  searchDispatchDetailsByStatus(searchvalue: any, pageid: number, rowid: number) {
    return this.http.get(this.url.searchDispatchDetailsByStatus + '?searchInput=' + searchvalue +
      '&page=' + pageid + '&rows=' + rowid);
  }
  // getAllDispatches
  getAllDispatchDetailsByStatus(pageid: number, rowid: number) {
    return this.http.get(this.url.getAllDispatchDetailsByStatus +
      '&page=' + pageid + '&rows=' + rowid);
  }
  // putcalls
  // update dispatchdetails
  updatedispatchdetails(obj: any) {
    return this.http.update(this.url.updatedespatchdetails, obj);
  }
  removeAddress(addressId: any) {
    return this.http.update(this.url.removeAddress + '?dispatchRecipientId=' + addressId, '')

  }
  // post calls
  // createdispatch
  // newDispatch(fileArray: any, obj: any) {
  //   const formData: FormData = new FormData();
  //   for (let i = 0; i < fileArray.length; i++) {
  //     formData.append('file', fileArray[i]);
  //   }
  //   formData.append('dispatchJson', JSON.stringify(obj));
  //   return this.http.post(this.url.createDispatch, formData);
  // }

  // put calls
  updateDespatch(fileArray: any, obj: any) {
    var formData: FormData = new FormData();
    for (let i = 0; i < fileArray.length; i++) {
      formData.append('file', fileArray[i].documentId);
      formData.append('toAddress', fileArray[i].toAddress);
      formData.append('endorseeAddress', fileArray[i].endorseeAddress);
    }
    formData.append('dispatchJson', JSON.stringify(obj));
    return this.http.updateData(this.url.updateDispatch, formData);
  }
  //  returnDispatchToSE
  returnDispatchToSE(dispatchid: any, comments: any) {
    return this.http.update(this.url.returnDispatchToSectionExecutive + '?dispatchId='
      + dispatchid + '&comments=' + comments, '');
  }
  // approveDispatch
  approveDispatchh(dispatchid: any, loggedinuserid: any) {
    return this.http.update(this.url.approveAndForwardtoDSE + '?dispatchId='
      + dispatchid + '&loggedInUserId=' + loggedinuserid, '');
  }


  // New Post Call
  seekApprovalList() {
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.SeekApproval, obj);
  }
  approveDispatch(data: any) {
    return this.http.post(this.url.approveDispatch, data);
  }
  seekApprovalByUserIDAndComments(data: any) {
    return this.http.post(this.url.seekApprovalByUserIDAndComments, data);
  }

  sendCorrection(data: any) {
    return this.http.post(this.url.sendCorrection, data);
  }
  getDispatchVia() {
    return this.http.get(this.url.getDispatchVia);
  }
  usersList(dispatchId: any) {
    return this.http.get(this.url.usersList + '?dispatchId=' + dispatchId);
  }
  getDispatchConfidentiality() {
    return this.http.get(this.url.getDispatchConfidentiality);
  }
  getAllDispatchCategories() {
    return this.http.get(this.url.getAllDispatchCategories);
  }
  getAllDispatchesUrgency() {
    return this.http.get(this.url.getAllDispatchesUrgency);
  }
  getAllReceiptLanguages() {
    return this.http.get(this.url.getAllReceiptLanguages);
  }

  getSSAStatusList() {
    return this.http.get(this.url.SSStatusList);
  }
  getCorrectionStatusList() {
    return this.http.get(this.url.correctionStatusList);
  }
  // Dashboard API
  dashboardList(obj: any, pageid: any, rowid: any) {
    if (obj === null) {
      return this.http.get(this.url.dashBoardURL + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
        + '&page=' + pageid + '&rows=' + rowid);
    } else {
      return this.http.get(this.url.dashBoardURL + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
        + obj + '&page=' + pageid + '&rows=' + rowid);
    }

  }

  //Correction Dashboard 
  getCorrectionListDashboard(dispatchDashboardSearchCriteria: any ) {
    return this.http.post(this.url.getCorrectionListDashboard, dispatchDashboardSearchCriteria);
}

  //Dashboard 
  GetDispatchList(dispatchDashboardSearchCriteria: any ) {
      return this.http.post(this.url.GetDispatchList,dispatchDashboardSearchCriteria);
  }

  //Dispatch Dashboard Changes
  GetDispatchListDispatchDashboard(dispatchDashboardSearchCriteria: any ) {
    return this.http.post(this.url.GetDispatchListDispatchDashboard,dispatchDashboardSearchCriteria);
  }

  //Section Executive Track 
  GetTrackDispatchListBySecExecutive(dispatchDashboardSearchCriteria: any ) {
    return this.http.post(this.url.GetTrackDispatchListBySecExecutive,dispatchDashboardSearchCriteria);
  }

  //Section Incharge Track 
  GetTrackDispatchListByInCharge(dispatchDashboardSearchCriteria: any ) {
    return this.http.post(this.url.GetTrackDispatchListByInCharge,dispatchDashboardSearchCriteria);
  }

  getDispatchListDairydakIncharge(dispatchDashboardSearchCriteria: any ) {
    return this.http.post(this.url.getDispatchListDairydakIncharge, dispatchDashboardSearchCriteria);
  }

  getDakDispatchReportList(diaryDakReportSearchCriteria: any ) {
    return this.http.post(this.url.getDakDispatchReportList, diaryDakReportSearchCriteria);
  }

  getDakDispatchReportViewList(dakDispatchFileNo: any ) {
    return this.http.post(this.url.getDakDispatchReportViewList, dakDispatchFileNo );
}
  dashboardListTrack(obj: any, pageid: any, rowid: any) {
    if (obj === null) {
      return this.http.get(this.url.dashBoardURLTrack + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
        + '&page=' + pageid + '&rows=' + rowid);
    } else {
      return this.http.get(this.url.dashBoardURLTrack + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
        + obj + '&page=' + pageid + '&rows=' + rowid);
    }

  }
  // Dashboard API
  dashboardListDispatched(obj: any, pageid: any, rowid: any) {
    if (obj === null) {
      return this.http.get(this.url.dashBoardURLDispatched + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
        + '&page=' + pageid + '&rows=' + rowid);
    } else {
      return this.http.get(this.url.dashBoardURLDispatched + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
        + obj + '&page=' + pageid + '&rows=' + rowid);
    }

  }
  otherSecDispatchList(pageid: any, rowid: any) {
    return this.http.get(this.url.dashBoardURL + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
      + '&page=' + pageid + '&rows=' + rowid);
  }
  fileDetailsList(fileId: any, fromDate: any, toDate: any, pageid: any, rowid: any) {
    // return this.http.get(this.url.popupFileData + '?dakDispatchFileId=' + fileId +
    //  '&userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
    //   + '&fromDate=' + fromDate + '&toDate=' + toDate + '&page=' + pageid + '&rows=' + rowid);

    return this.http.get(this.url.popupFileData + '?dakDispatchFileId=' + fileId 
      + '&page=' + pageid + '&rows=' + rowid);
  }
  fileList(fileId: any,pageid: any, rowid: any) {
    // return this.http.get(this.url.popupFileData + '?dakDispatchFileId=' + fileId +
    //  '&userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
    //   + '&fromDate=' + fromDate + '&toDate=' + toDate + '&page=' + pageid + '&rows=' + rowid);

    return this.http.get(this.url.popupFileData + '?dakDispatchFileId=' + fileId +
      '&userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
      + '&page=' + pageid + '&rows=' + rowid);
  }

  // Correction List 
  getCorrectionList(obj: any, pageid: any, rowid: any) {
    if (obj === null) {
      return this.http.get(this.url.getAllCorrectionList + '?page=' + pageid + '&rows=' + rowid);
    } else {
      return this.http.get(this.url.getAllCorrectionList + '?page=' + pageid + '&rows=' + rowid + obj);
    }
  }
  statusCorrectionList(statusName: any, pageId: number, rows: number) {
    return this.http.get(this.url.statusCorrectionList +
      '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&statusName=' + statusName
      + '&page=' + pageId + '&rows=' + rows);
  }
  searchCorrectionList(searchInput: any, pageId: number, rows: number) {
    return this.http.get(this.url.searchCorrectionList + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
      + '&page=' + pageId + '&rows=' + rows + '&searchInput=' + searchInput);
  }

  datesCorrectionList(fromDate: any, endDate: any, pageId: number, rows: number) {
    return this.http.get(this.url.searchCorrectionList + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
      + '&startDate=' + fromDate + '&endDate=' + endDate + '&page=' + pageId + '&rows=' + rows);
  }


  sendToEc(data: any) {
    return this.http.post(this.url.sendToEC, data);
  }

  sentCorrection(data: any) {
    return this.http.post(this.url.correctionRequired, data);
  }

  assignedDispatch(data: any) {
    return this.http.post(this.url.assignedDispatch, data);
  }

  approvedDispatchAssigned(data: any) {
    return this.http.post(this.url.approvedDispatchAssigned, data);
  }

  assignedDispatchNoteSheet(data: any) {
    return this.http.post(this.url.assignedDispatchNoteSheet, data);
  }

  majorCorrection(data: any) {
    return this.http.post(this.url.majorCorrection, data);
  }
  minorCorrection(data: any) {
    return this.http.post(this.url.minorCorrection, data);
  }
  dispatchApprove(data: any) {
    return this.http.post(this.url.approveDispatch, data);
  }

  approveFinalize(data: any) {
    return this.http.post(this.url.approveFinalize, data);
  }

  signandApprove(data: any) {
    return this.http.post(this.url.signandApprove, data);
  }

  signChangesReverted(dispatchId: any) {
    return this.http.get(this.url.signChangesReverted + '?dispatchId=' + dispatchId);
  }

  getBaseStringDispatch(data: any) {
    return this.http.post(this.url.getBaseStringDispatch, data);
  } 

  getDispatchNumberGeneration(data: any) {
    return this.http.post(this.url.dispatchNumberGeneration, data);
  }
  
  signAndUpload(obj: any) {
    return this.http.post(this.url.signAndUpload, obj);
  }

  getCorrectionUsersList(dispatchId: any) {
    const obj = {
      dispatchIdEncr: this.ced.encryptAesToString(dispatchId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getAllCorrectionUsers, obj)

  }
  getCorrectionUsersListSectionIncharge(dispatchId: any) {
    return this.http.get(this.url.getAllCorrectionUsersSectionIncharge + '?dispatchId=' + dispatchId + '&userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId)

  }
  circulationDecision(data: any) {
    return this.http.post(this.url.circulationDecision, data);
  }

  updateDocument(dispatchId: any, isDraft: any, eCCirculationsToggle: any, fileArray: any) {
    const formData: FormData = new FormData();
    for (let i = 0; i < fileArray.length; i++) {
      formData.append('file', fileArray[i]);
    }

    return this.http.update(this.url.upDateDocument + '?dispatchId=' + dispatchId + '&loggedInUserId=' +
      JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&assignedToUserId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
      + '&isDraft=' + isDraft + '&eCCirculationsToggle=' + eCCirculationsToggle, formData);
  }

  ecToggle(dispatchId: any, flag: any) {
    return this.http.update(this.url.ecToggle + '?dispatchId=' + dispatchId + '&loggedInUserId=' +
      JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&flag=' + flag, '');
  }
  dashboardStatus() {
    return this.http.get(this.url.dashboardStatus)
  }
  processHistory(dispatchId: any) {
    const obj = {
      dispatchIdEncr: this.ced.encryptAesToString(dispatchId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.processhistory, obj);
  }
  getUserName(roleName: any) {
    const roleNameEncr = encodeURIComponent(this.ced.encryptAesToString(roleName, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getUserListByRoleName + '?roleNameEncr=' + roleNameEncr);
  }
  // getAddressCategory
  getAddressCategory() {
    return this.http.get(this.url.getAddressCategory);
  }
  // getUsersByDesignation
  getUsersByDesignation(designationName, sectionname) {
    return this.http.get(this.url.getUsersByDesignation + '?designation=' + designationName + '&section=' + sectionname);
  }
  // getAddressType
  getAddressType() {
    return this.http.get(this.url.getAddressType);
  }
  //  call multiple Api calls Into Single 
  getCalls(data: any,pageid:any,rowid:any) {
    if (data === '1') {
      return this.http.get(this.url.getAllPrincipal +'?page='+pageid+'&rows='+rowid);
    } else if (data === '2') {
      return this.http.get(this.url.getAllDME+'?page='+pageid+'&rows='+rowid);
    } else if (data === '3') {
      return this.http.get(this.url.getAllHealthSecy+'?page='+pageid+'&rows='+rowid);
    }
    else if (data === '7') {
      return this.http.get(this.url.getAllSDC +'?page='+pageid+'&rows='+rowid);
    }  else if (data === '8') {
      return this.http.get(this.url.getAllUniversity +'?page='+pageid+'&rows='+rowid);
    } else if (data === '9') {
      return this.http.get(this.url.getAllCounsellingAuthority +'?page='+pageid+'&rows='+rowid);
    } else {
      return this.http.get(this.url.getAllAdvocate +'?page='+pageid+'&rows='+rowid);
    }
  }

  // getAllMinistry
  getAllMinistry() {
    return this.http.get(this.url.getAllMinistry);
  }


  // filter With state and Name
  searchPrincipalData(stateId: any, principalName: any,pageid:any,rowid:any) {
    if (stateId !== null && principalName !== null) {
      return this.http.get(this.url.getAllPrincipal + '?stateId=' + stateId + '&principalName=' + principalName+'&page='+pageid +'&rows='+rowid);
    } else if (stateId === '' && principalName !== '') {
      return this.http.get(this.url.getAllPrincipal + '?principalName=' + principalName+'&page='+pageid +'&rows='+rowid);
    } else if (stateId !== '' && principalName === '') {
      return this.http.get(this.url.getAllPrincipal + '?stateId=' + stateId+'&page='+pageid +'&rows='+rowid);
    } 
  }
  // filter With state and Name with University
  searchUniversityData(stateId: any, principalName: any,pageid:any,rowid:any) {
    if (stateId !== null && principalName !== null) {
      return this.http.get(this.url.getAllUniversity + '?stateId=' + stateId + '&principalName=' + principalName+'&page='+pageid +'&rows='+rowid);
    } else if (stateId === '' && principalName !== '') {
      return this.http.get(this.url.getAllUniversity + '?principalName=' + principalName+'&page='+pageid +'&rows='+rowid);
    } else if (stateId !== '' && principalName === '') {
      return this.http.get(this.url.getAllUniversity + '?stateId=' + stateId+'&page='+pageid +'&rows='+rowid);
    } 
  }
  // SearchWith DME
  searchDMEData(stateId: any, dmeName: any,pageid:any,rowid:any) {
    if (stateId !== null && dmeName !== null) {
      return this.http.get(this.url.getAllDME + '?stateId=' + stateId + '&dmeName=' + dmeName+'&page='+pageid +'&rows='+rowid);
    } else if (stateId === '' && dmeName !== '') {
      return this.http.get(this.url.getAllDME + '?dmeName=' + dmeName+'&page='+pageid +'&rows='+rowid);
    } else if (stateId !== '' && dmeName === '') {
      return this.http.get(this.url.getAllDME + '?stateId=' + stateId+'&page='+pageid +'&rows='+rowid);
    }
  }

  // Health Secretary
  searchHealthSecData(stateId: any, secName: any,pageid:any,rowid:any) {
    if (stateId !== '' && secName !== '') {
      return this.http.get(this.url.getAllHealthSecy + '?stateId=' + stateId + '&secName=' + secName+'&page='+pageid +'&rows='+rowid);
    } else if (stateId === '' && secName !== '') {
      return this.http.get(this.url.getAllHealthSecy + '?secName=' + secName+'&page='+pageid +'&rows='+rowid);
    } else if (stateId !== '' && secName === '') {
      return this.http.get(this.url.getAllHealthSecy + '?stateId=' + stateId+'&page='+pageid +'&rows='+rowid);
    } else {
      return this.http.get(this.url.getAllHealthSecy+'?page='+pageid +'&rows='+rowid);
    }
  }

  // Health Secretary
  searchSDCData(stateId: any, secName: any,pageid:any,rowid:any) {
    if (stateId !== '' && secName !== '') {
      return this.http.get(this.url.getAllSDC + '?stateId=' + stateId + '&secName=' + secName+'&page='+pageid +'&rows='+rowid);
    } else if (stateId === '' && secName !== '') {
      return this.http.get(this.url.getAllSDC + '?secName=' + secName+'&page='+pageid +'&rows='+rowid);
    } else if (stateId !== '' && secName === '') {
      return this.http.get(this.url.getAllSDC + '?stateId=' + stateId+'&page='+pageid +'&rows='+rowid);
    } else {
      return this.http.get(this.url.getAllSDC+'?page='+pageid +'&rows='+rowid);
    }
  }
  // Advocate Data
  searchAdvocateSecData(stateId: any, advocateName: any,pageid:any,rowid:any) {
    if (stateId !== '' && advocateName !== '') {
      return this.http.get(this.url.getAllAdvocate + '?stateId=' + stateId + '&advocateName=' + advocateName+'&page='+pageid +'&rows='+rowid);
    } else if (stateId === '' && advocateName !== '') {
      return this.http.get(this.url.getAllAdvocate + '?advocateName=' + advocateName+'&page='+pageid +'&rows='+rowid);
    } else if (stateId !== '' && advocateName === '') {
      return this.http.get(this.url.getAllAdvocate + '?stateId=' + stateId+'&page='+pageid +'&rows='+rowid);
    } else {
      return this.http.get(this.url.getAllAdvocate+'?page='+pageid +'&rows='+rowid);
    }
  }

  // Counselling Authority Data
  searchCounsellingAuthority(stateId: any, caName: any,pageid:any,rowid:any) {
    if (stateId !== '' && caName !== '') {
      return this.http.get(this.url.getAllCounsellingAuthority + '?stateId=' + stateId + '&caName=' + caName+'&page='+pageid +'&rows='+rowid);
    } else if (stateId === '' && caName !== '') {
      return this.http.get(this.url.getAllCounsellingAuthority + '?caName=' + caName+'&page='+pageid +'&rows='+rowid);
    } else if (stateId !== '' && caName === '') {
      return this.http.get(this.url.getAllCounsellingAuthority + '?stateId=' + stateId+'&page='+pageid +'&rows='+rowid);
    } else {
      return this.http.get(this.url.getAllCounsellingAuthority+'?page='+pageid +'&rows='+rowid);
    }
  }

  // getAllBulkCategory
  getAllBulkCategory() {
    return this.http.get(this.url.getAlLBulkCategory);
  }
  // searchWithFileNum
  searchWithFileNum(fileno, pageid, rowid,sectionId) {
    const obj = {
      page: pageid,
      rows: rowid,
      fileNum: fileno,
      sectionIdEncr: this.ced.encryptAesToString(sectionId, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.searchWithFileNum, obj)
  }
  wordDocument(): Observable<Blob>
  {
    return this.http.get<Blob>(this.url.wordDocument)
  }
  // getOtherSectionReceiptsByUserId
  getOtherSectionReceiptsByUserId(userid: any, pageid: any, rowid: any, sectionid: any) {
    return this.http.get(this.url.getOtherSectionReceiptsByUserId + '?userId=' + userid + '&page=' + pageid + '&rows=' + rowid +
      '&statusName=' + 'Assigned' + '&sectionId=' + 1)
  }

  //uploadSignedPdf
  uploadSignedPdf(dispatchId: any, file: any) {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(this.url.uploadSignedPdf + '?dispatchId=' + dispatchId, formData);
  }
  // getUnsignedPdf
  getUnsignedPdf(dispatchId) {
  const obj = {
    dispatchIdEncr: this.ced.encryptAesToString(dispatchId, this.serverURL.secretKey).toString(),
  }
    return this.http.post(this.url.getUnsignedPdf, obj);
  }
  //sendMailDispatch
  sendMailDispatch(dispatchId: any, obj: any) {
    const dispatchObj=  {
      dispatchId: dispatchId,
      sectionId: JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId,
      roleName: sessionStorage.getItem('selectedRole-usec'),
      schedule: false
    }
    return this.http.post(this.url.sendMailDispatch, dispatchObj);
  }

  //sendMailDispatchwithmappedattachments
  sendMailDispatchwithmappedattachments(dispatchId: any, obj: any, documentDetailList: any) {
    return this.http.post(this.url.sendMailDispatchwithmappedattachments + '?dispatchId=' + dispatchId,documentDetailList);
  }
  // getAllSectionHeads
  getAllSectionHeads(sectionName) {
    return this.http.get(this.url.getAllSectionHeads + '?sectionName=' + sectionName);
  }


  // Save Dispatch
  saveDispatch(fileArray: any, obj: any, data: any) {
    const formData: FormData = new FormData();
    for (let i = 0; i < fileArray.length; i++) {
      formData.append('file', fileArray[i].documentId);
      formData.append('toAddress', fileArray[i].toAddress);
      formData.append('endorseeAddress', fileArray[i].endorseeAddress);
    }
   // formData.append('stdAdmissionIdList', stdAdmissionId);

    formData.append('dispatchJson', JSON.stringify(obj));
    if (data === 'save') {
      return this.http.post(this.url.savedispatch, formData);
    } else {
      return this.http.post(this.url.createDispatch, formData);
    }
  }

  // create Dispatch
  newDispatch(fileArray: any, obj: any) {
    const formData: FormData = new FormData();
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < fileArray.length; i++) {
      formData.append('file', fileArray[i]);
    }
    formData.append('dispatchJson', JSON.stringify(obj));
    return this.http.post(this.url.createDispatch, formData);
  }
  // processHistory
  history(dispatchId: any) {
    const obj = {
      dispatchIdEncr: this.ced.encryptAesToString(dispatchId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.processHistory, obj);
  }
  // getDFASubjectSearch
  searchDFASubject(userId, subSearch, pageid, rowid) {
    return this.http.get(this.url.searchDfaSubject + '?userId=' + userId + '&subSearch=' + subSearch + '&page=' + pageid + '&rows=' + rowid)
  }
  // getDFASubjectSearch
  searchDFASubjectTrack(userId, subSearch, pageid, rowid) {
    return this.http.get(this.url.searchDfaSubjectTrack + '?userId=' + userId + '&subSearch=' + subSearch + '&page=' + pageid + '&rows=' + rowid)
  }

  searchDFASubjectTrackInc(userId, subSearch, pageid, rowid) {
    return this.http.get(this.url.searchDfaSubjectTrackInc + '?userId=' + userId + '&subSearch=' + subSearch + '&page=' + pageid + '&rows=' + rowid)
  }
   // getDispatchNumberSearch
   searchDispatchNumber(userId, dispatchNo, pageid, rowid) {
    return this.http.get(this.url.searchDispatchNumber + '?userId=' + userId + '&dispatchNo=' + dispatchNo + '&page=' + pageid + '&rows=' + rowid);
  }
  // getDispatchNumberSearch
  searchDispatchNumberTrack(userId, dispatchNo, pageid, rowid) {
    return this.http.get(this.url.searchDispatchNumberTrack + '?userId=' + userId + '&dispatchNo=' + dispatchNo + '&page=' + pageid + '&rows=' + rowid);
  }

  searchDispatchNumberTrackInc(userId, dispatchNo, pageid, rowid) {
    return this.http.get(this.url.searchDispatchNumberTrackInc + '?userId=' + userId + '&dispatchNo=' + dispatchNo + '&page=' + pageid + '&rows=' + rowid);
  }
   // getDFASubjectSearch
   searchDFASubjectDispatched(userId, subSearch, pageid, rowid) {
    return this.http.get(this.url.searchDFASubjectDispatched + '?userId=' + userId + '&subSearch=' + subSearch + '&page=' + pageid + '&rows=' + rowid)
  }
   // getDispatchNumberSearch
   searchDispatchNumberDispatched(userId, dispatchNo, pageid, rowid) {
    return this.http.get(this.url.searchDispatchNumberDispatched + '?userId=' + userId + '&dispatchNo=' + dispatchNo + '&page=' + pageid + '&rows=' + rowid);
  }
  // senderDesignationUserList
  senderDesignationUserList(){
    const roleNameEncr= encodeURIComponent(this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString());
    return this.http.get(this.url.senderDesignationUserList + '?roleNameEncr=' + roleNameEncr);
  }
  // Preview pdf
  previewPdf(dispatchId:any){
    const obj = {
      dispatchIdEncr: this.ced.encryptAesToString(dispatchId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.PreviewPDF, obj);
  }
  // getCategoryBySubsection
  getCategoryBySubsection(subsectionId:any){
    return this.http.get(this.url.get_file_category_from_sub_section +'?subSectionId='+subsectionId);
  }
  // getSubCategoryByFileCategory
  getSubCategoryByFileCategory(filecategoryId:any){
    return this.http.get(this.url.get_file_sub_category_from_file_category +'?fileCategoryId='+filecategoryId)
  }
  // getReferenceBySubCategory
  getReferenceBySubCategory(fileSubCategoryId:any){
    return this.http.get(this.url.get_file_subject_reference_from_file_sub_category +'?fileSubCategoryId='+fileSubCategoryId);
  }
  // getAllCollege
  getAllCollege(){
    return this.http.get(this.url.get_all_college);
  }
  // getSubCategoryReferenceBySubCategory
  getSubCategoryReferenceBySubCategory(fileSubCategoryId:any){
    return this.http.get(this.url.get_file_sub_category_reference_from_file_sub_category +'?fileSubCategoryId='+fileSubCategoryId);
  }
  // delete Document
  deleteDocument(documentId:any){
    return this.http.delete(this.url.delete_document+'?documentId='+documentId);
  }
  // preview Document
  previewDoc(id:any){
    return this.http.get(this.url.documentUrl+'?uuid='+id);
  }
  // previewFinalLetter
  previewFinalLetter(id:any,filepath:any){
    return this.http.get(this.url.previewFinalLetter+'?uuid='+id+'&filePath='+filepath);
  }
  // trackNoteSheet
  trackNoteSheet(userId:any,pageid:any,rowid:any){
    return this.http.get(this.url.trackNoteSheet+'?userId='+userId+'&page='+pageid +'&rows=' +rowid);
  }
  // trackNoteSheet
  trackNoteSheetSecExec(userId:any,pageid:any,rowid:any){
    return this.http.get(this.url.trackNoteSheetSecExec+'?userId='+userId+'&page='+pageid +'&rows=' +rowid);
  }
  // getotherCategoryusers
  getotherCategoryusers(userName:any,phoneNumber:any,pageid:any,rowid:any){
    return this.http.get(this.url.get_other_category_users+'?userName='+userName+'&phoneNumber='+phoneNumber+'&page='+pageid +'&rows=' +rowid);
  }
  // saveFileNum
  saveFileNum(obj){
    return this.http.post(this.url.saveFileNum,obj)
  }

  getHistoryNoteSheet(userId:any,pageid:any,rowid:any){
    return this.http.get(this.url.getHistoryNoteSheet+'?userId='+userId+'&page='+pageid +'&rows=' +rowid);
  }
  // Delete Dispatch
  deleteDispatch(id:any){
    const dispatchObj=  {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString(),
      dispatchIdEncr: this.ced.encryptAesToString(id, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.deleteDispatch,dispatchObj);
  }
undoDispatch(id: any) {
  const dispatchObj = {
    roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'),this.serverURL.secretKey).toString(),
    dispatchIdEncr: this.ced.encryptAesToString(id, this.serverURL.secretKey).toString(),
  };
  return this.http.post(this.url.undoDispatch, dispatchObj);
}
   // getDispatchById
   getClarificationById(id: any) {
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString(),
      clarIdEncr: this.ced.encryptAesToString(id, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getClarificationById, obj);
  }

  // getAllFwdReceiptById
  getAllFwdClarificationtById(dispatchId){
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString(),
      dispatchIdEncr: this.ced.encryptAesToString(dispatchId, this.serverURL.secretKey).toString(),
    }
  return this.http.post(this.url.getAllFwdClarificationtById, obj);
}
//assignToAnyDesignation
  assignClarificationToAnyDesignation(data: any) {
    return this.http.update(this.url.assignClarificationToAnyDesignation, data);
  }

  //assignToAnyDesignation
  noteSheetClosed(data: any) {
    return this.http.update(this.url.noteSheetClosed, data);
  }

  //assignToAnyDesignation
  assignClarificationToSectionHead(data: any) {
    return this.http.update(this.url.assignClarificationToSectionHead, data);
  }

  //assignToAnyDesignation
  approvedClarificationToSectionHead(data: any) {
    return this.http.update(this.url.approvedClarificationToSectionHead, data);
  }

  //submit To SectionHead Clarification
  submitToSectionHead(id, obj: any) {
    return this.http.update(this.url.submitToSectionHead + '?dispatchId=' + id + '&sectionId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId, obj)
  }

  // Notification details by Kannan
  getNotificationList(){
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
    }    
    return this.http.post(this.url.dakNotificationList, obj);
  }

  getClarificationList(){
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.clarificationNotificationList, obj);
  }

  getOtherSectionDispatchList(){
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.otherSectionDispatchNotificationList, obj);
  }

  //uploadFileWithContent
  uploadFileWithContent(file: any, obj: any) {
    const formData: FormData = new FormData();
    for (let i = 0; i < file.length; i++) {
      formData.append('file', file[i]);
    }    
    formData.append('dispatchJson', JSON.stringify(obj));
    return this.http.post(this.url.uploadFileWithContent , formData);
  }

  // getAllFwdReceiptById
  getClarificationDocuments(dispatchId){
    const obj = {
      dispatchIdEncr: this.ced.encryptAesToString(dispatchId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getClarificationDocuments, obj);
  }

  // delete Document
  deleteDocumentOtherSection(documentId:any){
    return this.http.delete(this.url.deleteDocumentOtherSection+'?documentId='+documentId);
  }

  saveFileStructureSubCategory(saveFileStructureSubCategoryDTO:any){
     return this.http.post(this.url.saveFileStructureSubCategory, saveFileStructureSubCategoryDTO);
  }

  saveFileStructureFileReference(saveFileStructureFileReferenceDTO:any){ 
     return this.http.post(this.url.saveFileStructureFileReference, saveFileStructureFileReferenceDTO);
  }

  otherExeWithSearch(obj:any,pageid:any,rowid:any){
  if (obj === null) {
    return this.http.get(this.url.otherExeWithSearch + '?page=' + pageid + '&rows=' + rowid);
  } else {
    return this.http.get(this.url.otherExeWithSearch + '?page=' + pageid + '&rows=' + rowid + obj);
  }  }
    
  
  searchDispatchNumberOtherExe(dispatchNo, pageid, rowid) {
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString(),
      dispatchNo: dispatchNo,
      page: pageid,
      rows: rowid
    }
      return this.http.post(this.url.searchDispatchNumberOtherExe, obj);
    }

  searchDFASubjectOtherExe(subSearch, pageid, rowid) {
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString(),
      subSearch: subSearch,
      page: pageid,
      rows: rowid
    }
    return this.http.post(this.url.searchDFASubjectOtherExe, obj);
  }

  noteSheetClosedWithoutDFA(data: any) {
    return this.http.update(this.url.noteSheetClosedWithoutDFA, data);
  }

  getExistsAgendaDetailsDispatch(dispatchId:any) {
    return this.http.get(this.url.getExistsAgendaDetailsDispatch + '?dispatchId=' + dispatchId);
  }

  //Other Dispatch
  otherIncWithSearch(sectionId:any,obj:any,pageid:any,rowid:any){
    if (obj === null) {
      return this.http.get(this.url.otherIncWithSearch + '?sectionId=' + sectionId
        + '&page=' + pageid + '&rows=' + rowid);
    } else {
      return this.http.get(this.url.otherIncWithSearch + '?sectionId=' + sectionId
        + obj + '&page=' + pageid + '&rows=' + rowid);
    }  }

    searchDispatchNumberOtherInc(sectionId, dispatchNo, pageid, rowid) {
      return this.http.get(this.url.searchDispatchNumberOtherInc + '?sectionId=' + sectionId + '&dispatchNo=' + dispatchNo + '&page=' + pageid + '&rows=' + rowid);
    }

    searchDFASubjectOtherInc(sectionId, subSearch, pageid, rowid) {
      return this.http.get(this.url.searchDispatchNumberOtherInc + '?sectionId=' + sectionId + '&subSearch=' + subSearch + '&page=' + pageid + '&rows=' + rowid)
    }

    updateDocumentsType(dispatchId: any, fileArray: any) {
      const formData: FormData = new FormData();
    for (let i = 0; i < fileArray.length; i++) {
      formData.append('dispatchDocumentId', fileArray[i].dispatchDocumentId);
      formData.append('files', fileArray[i].documentId);
      formData.append('toAddress', fileArray[i].toAddress);
      formData.append('endorseeAddress', fileArray[i].endorseeAddress);
    }
    formData.append('dispatchId', dispatchId);
      return this.http.post(this.url.updateDocumentsType, formData);
    }
    DownloadAntiRaggingApplication(antiRaggingId:any)
    {
      return this.http.get(this.url.DownloadAntiRaggingApplication+"?antiRaggingId="+antiRaggingId);
    }

    GetAntiRaggingAcademicYear(antiRaggingId:any)
    {
      return this.http.get(this.url.GetAntiRaggingAcademicYear+"?antiRaggingId="+antiRaggingId);
    }

    // Get All Academic Year List
    academicYearListByDispatch() {
      return this.http.get(this.url.getAllacademicYearListByDispatch);
    }

    getQuaterlyReportByYear(obj: any) {
        return this.http.post(this.url.getQuaterlyReport, obj);
    }
}